import React, { Component } from "react";
import { USERURL } from '../../constant';


import {Helmet} from "react-helmet";

import logoBewise from '../../assets/images/bewise_logo_mini.png';
import logoBewisemini from '../../assets/images/bewise_logo_mini.png';

class HeaderNew extends Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    this.state = {
      authe: false,
      tabmoved:false,
      logged_user_name: "",
      login_path: path == '/' ? '/admin_login' : '/login',
      signup_path: path == 'individual' ? '/individual_signup' : '/institution_signup',
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleOpenTab1 = this.toggleOpenTab1.bind(this);
    this.toggleOpenTab2 = this.toggleOpenTab2.bind(this);
  }
  componentDidMount() {
    console.log('window.location.pathname', window.location.pathname);
    let logged = localStorage.getItem("authentication");
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    console.log("auth_data", typeof logged);
    if (auth_data) {
      this.setState({
        authe: logged == "true" ? true : false,
        logged_user_name: auth_data.user_name,
      });
    }
    let schoolpreschoolselected = this.props.schoolpreschoolselected;
    let otherselected = this.props.otherselected;
    this.setState({schoolpreschoolselected:schoolpreschoolselected,otherselected:otherselected});

    window.addEventListener('scroll', this.handleScroll); 
  }

  
  handleScroll = () => {
    
   
     if(window.scrollY>=800){
         this.setState({tabmoved:true});
     }else{
      this.setState({tabmoved:false});
     }
  
 };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
}


toggleOpenTab1 = (e) => {
  this.props.toggleOpenTab1();
  this.setState({schoolpreschoolselected:true, otherselected:false});
  window.scrollTo(150,300);
}

toggleOpenTab2 = (e) => {
  this.props.toggleOpenTab2();
  this.setState({schoolpreschoolselected:false, otherselected:true});
  window.scrollTo(150,300)
}

  logoutSess(e) {
    localStorage.clear();
    setTimeout(function () {
      window.location = "/";
    }, 1000);
  }
  render() {

    const { tabmoved} = this.state;

    return (


          <div style={{
              position: "fixed",
              zIndex: "999",
              background: "#fff",
              width: "100%",
              top: 0
          }} class="container-fluid">

          <div className='tranparent-header-custom-inner'>
            <div className='container-fluid'>
              <div className='row display-flex-center header-custom stickymenu sticky-top desktop'>
                <div className='col-lg-3 col-md-3 col-sm-3 bewise-logo-block'>
                  <div className='bewise-logo active'>
                    <div class="row  display-flex-center">
                      <div>
                        <a className='logo-text' href='/'>
                          <img src={logoBewise} className="mainlogoimg" style={{ width: "100%", marginRight: "2px" }} />
                        </a>
                      </div>
                       
                    </div>
                  </div>
                </div>

                <div className='col-lg-6 col-md-6 col-sm-6' style={{ textAlign: "center" }}>
                  <div className="topheading mainsearchareatop s003" style={{ display: "none" }}>
                      <div class="bheader">Welcome to <span className="bluetext">BeWise</span> Partner Program</div>
                  </div>
                </div>
                <div className='col-lg-3 col-md-3 col-sm-3 text-right bewise-signin-block'>
                     <a href="/login" className="nsignbtn">Sign In</a>
                </div>
              </div>

              <div className='mobile'>

                <div class="mobiletopmenu">
                <div className='bewise-logo-block' style={{ paddingLeft: "0px"}}>
                  <div className='bewise-logo active'>
                    <div class="leftLogo"><a className='logo-text' href='/'>
                          <img src={logoBewisemini} className="mainlogoimg" style={{ width: "55px", marginRight: "2px" }} />
                        </a>
                    </div>
                  </div>
                </div>
                
                <div className='text-right bewise-signin-block'>
                     <a href="/login" className="nsignbtn">Sign In</a>
                </div>
                </div>

              </div>

              <div className='row align-items-center mobile slogn'>
                <div className='col-sm-12' style={{ textAlign: "center" }}>
                    <div class="bheader">Welcome to <span className="blue2text">BeWise</span> Partner Program</div>
                </div>

              </div>

            </div>
          </div>
          {tabmoved &&
          <div class="partnerpricepage topheaders">
            <div class="tabs">
                            <div class="tabby-tab">
                              <input type="radio" id="tab-2" name="tabby-tabs" />
                              <label id="tab11" className={this.props.schoolpreschoolselected===true?'active':''} for="tab-2" onClick={this.toggleOpenTab1}><span>Schools & Pre-Schools</span></label>
                              
                            </div>

                            <div class="tabby-tab">
                              <input type="radio" id="tab-3" name="tabby-tabs" />
                              <label id="tab12" className={this.props.otherselected===true?'active':''} for="tab-3" onClick={this.toggleOpenTab2}><span>All Others</span></label>
                            
                            </div>
            </div>
          </div>
          }
                    
        </div>

    );
  }
}

export default HeaderNew;



// WEBPACK FOOTER //
// ./src/components/2023/HeaderNew.jsx